import clsx from 'clsx';
import type { OrgRole } from '../../api/client';

interface RoleBadgeProps {
  role: OrgRole;
  size?: 'sm' | 'md';
}

const ROLE_STYLES: Record<OrgRole, string> = {
  owner: 'text-gold bg-gold/10 border-gold/30',
  admin: 'text-brand bg-brand/10 border-brand/30',
  member: 'text-brand-light bg-brand/10 border-brand/30',
  viewer: 'text-gray-400 bg-surface-3 border-surface-4',
};

const ROLE_LABELS: Record<OrgRole, string> = {
  owner: 'OWNER',
  admin: 'ADMIN',
  member: 'MEMBER',
  viewer: 'VIEWER',
};

export function RoleBadge({ role, size = 'sm' }: RoleBadgeProps) {
  return (
    <span
      className={clsx(
        'inline-flex items-center font-semibold tracking-wide border rounded',
        size === 'sm' ? 'px-1.5 py-0.5 text-[10px]' : 'px-2 py-1 text-xs',
        ROLE_STYLES[role],
      )}
    >
      {ROLE_LABELS[role]}
    </span>
  );
}
